import React from 'react'
import { Login } from 'react-cognito'
import LoginForm from './LoginForm'

const LoggedOutPage = () => (
  <Login><LoginForm /></Login>
)

export default LoggedOutPage
